(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-griptape"] && !Shopify.designMode) return;
  try {
    
var griptapeOptionsSection = document.querySelector('section.griptape-options');
griptapeOptionsSection.childNodes.forEach(item=>{
  document.getElementById('griptape-options').appendChild(item);
});
document.getElementById('griptape-options').classList.add('product-form__controls-group');
  
var gripNone = document.getElementById("grip_none");
var gripNoneRadio = document.getElementById("grip_none_radio");
var griptapeRadios = document.getElementsByName("items[1]id");
gripInit(gripNone, gripNoneRadio, griptapeRadios);

var applyNone = document.getElementById("apply_none");
var applyNoneRadio = document.getElementById("apply_none_radio");
var applyRadios = document.getElementsByName("items[2]id");
applyInit(applyNone, applyNoneRadio, applyRadios);

  } catch(e) { console.error(e); }
})();
})();
